<template>
  <project-manager-layout :spinning="isLoading">
    <leader-project-layout :model="model">
      <template #underInfo>
        <div class="leader-project__common-progress" v-if="model.id">
          <progress-bar-generated
            :show-label="true"
            :show-percent="true"
            :completed="model.completedCount"
            :completed-overdue="model.completedOverdueCount"
            :incomplete-overdue="model.incompleteOverdueCount"
            :incomplete="model.incompleteCount"
          />
        </div>
      </template>

      <div class="project-students">
        <h3>Профиль студентов</h3>

        <div class="description" v-if="route.meta.role === USER_ROLE_LEADER">
          Проверьте сформировавшийся профиль проявленных качеств студентов
          проекта и при необходимости скорректируйте его.
        </div>

        <students-table :disabled="disabled" />
      </div>
    </leader-project-layout>
  </project-manager-layout>
</template>

<script setup>
  import { computed, onMounted, reactive, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import ProjectManagerLayout from '@/layouts/ProjectManagerLayout.vue';
  import LeaderProjectLayout from '@/views/leader/projects/components/LeaderProjectLayout.vue';
  import ProgressBarGenerated from '@/components/projects/portfolio/components/ProgressBarGenerated.vue';
  import { USER_ROLE_LEADER } from '@/api/models/UserRole';
  import StudentsTable from '@/views/leader/projects/students/components/StudentsTable.vue';
  import {
    PROJECT_STATUS_ACCEPTANCE,
    PROJECT_STATUS_CLOSED,
  } from '@/api/models/ProjectStatus';

  const api = useApi();
  const route = useRoute();
  const model = reactive({
    id: null,
    number: '',
    name: '',
    projectType: '',
    requestId: null,
    status: null,
    projectStatusId: null,
    isMyProject: false,
    showcase: null,
    publicShowcase: null,
    completedCount: 0,
    completedOverdueCount: 0,
    incompleteOverdueCount: 0,
    incompleteCount: 0,
  });
  const isLoading = ref(true);

  onMounted(async () => {
    await getModel();
    isLoading.value = false;
  });

  const disabled = computed(() => {
    return [PROJECT_STATUS_ACCEPTANCE, PROJECT_STATUS_CLOSED].includes(
      model.projectStatusId
    );
  });

  const getModel = async () => {
    try {
      const response = await api.leaderPage.view(route.params.id);
      model.name = response.project.name;
      model.number = response.project.id;
      model.id = response.project.id;
      model.type = response.project.type;
      model.requestId = response.project.requestId;
      model.status = response.project.status;
      model.projectStatusId = response.project.projectStatusId;
      model.isMyProject = response.project.isMyProject;
      model.completedCount = response.project.completedCount;
      model.completedOverdueCount = response.project.completedOverdueCount;
      model.incompleteOverdueCount = response.project.incompleteOverdueCount;
      model.incompleteCount = response.project.incompleteCount;
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .project-students {
    margin-top: 10px;

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    h4 {
      font-size: 14px;
      margin: 30px 0 6px;

      &.disabled {
        color: $color-bg-status-new !important;
      }
    }

    .description {
      font-family: 'Nunito Sans', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      max-width: 678px;
    }

    .actions {
      text-align: right;
      margin-top: 26px;

      .actions-remove_button {
        margin-right: 10px;
      }
    }

    .project-showcase-form {
      margin-top: 30px;
    }

    .project-showcase-form-row {
      margin-top: 14px;
    }
  }

  .project-showcase-form__checkboxes {
    & .c-checkbox {
      margin-bottom: 16px;
    }
  }
</style>
